import { IRegistration } from '../../store/registrations/interfaces'
import moment, { Moment } from 'moment'

type AgeCheckResult = {
  message?: string
  ok: boolean
}
type DateRange = [Moment, Moment]
type AgeRange = [number, number]

const asDateRange = (lower: Moment, upper: Moment): DateRange => [lower, upper]

export enum AgeInDateRangeResults {
  OK,
  FAILED_LOWER = 'Beginn',
  FAILED_UPPER = 'Ende',
}

export const ageInDateRange = (
  targetAgeRange: AgeRange,
  boundaryDates: DateRange,
  dateOfBirth: Moment,
  tolerance: number,
  relax: boolean
): AgeInDateRangeResults => {
  const birthDate = new Date(
    dateOfBirth.year(),
    dateOfBirth.month(),
    dateOfBirth.date()
  )
  let additionAge = moment(birthDate)
  let subtractionDate = moment(birthDate)
  const ageRangeAtStart = [
    boundaryDates[0].diff(additionAge.add(tolerance, 'd'), 'y'),
    boundaryDates[0].diff(subtractionDate.subtract(tolerance, 'd'), 'y'),
  ]
  additionAge = moment(birthDate)
  subtractionDate = moment(birthDate)
  const ageRangeAtEnd = [
    boundaryDates[1].diff(additionAge.add(tolerance, 'd'), 'y'),
    boundaryDates[1].diff(subtractionDate.subtract(tolerance, 'd'), 'y'),
  ]
  if (
    // Check the lower boundary
    !(relax
      ? // ok when: (minAge <= ageAtEventStart or minAge <= ageAtEventEnd) and ageAtEventStart <= maxAge
      (targetAgeRange[0] <= ageRangeAtEnd[1] ||
        targetAgeRange[0] <= ageRangeAtEnd[1]) &&
      ageRangeAtStart[0] <= targetAgeRange[1]
      : // ok when: minAge <= ageAtEventStart and ageAtEventStart <= maxAge
      targetAgeRange[0] <= ageRangeAtStart[1] &&
      ageRangeAtStart[0] <= targetAgeRange[1])
  ) {
    return AgeInDateRangeResults.FAILED_LOWER
  } else if (
    // Check the upper boundary
    !(relax
      ? // ok when: minAge <= ageAtEventEnd or ageAtEventEnd <= maxAge
      targetAgeRange[0] <= ageRangeAtEnd[1] ||
      ageRangeAtEnd[0] <= targetAgeRange[1]
      : // ok when: minAge <= ageAtEventEnd and ageAtEventEnd <= maxAge
      targetAgeRange[0] <= ageRangeAtEnd[1] &&
      ageRangeAtEnd[0] <= targetAgeRange[1])
  ) {
    return AgeInDateRangeResults.FAILED_UPPER
  } else {
    return AgeInDateRangeResults.OK
  }
}

export const checkWithinMaxAgeWithTolerance = (dateOfBirth: string, maxAge: number, tolerance: number): AgeCheckResult => {
  const birthDate = moment(dateOfBirth);
  const ageWithTolerance = moment().diff(birthDate.clone().subtract(tolerance, 'days'), 'years');
  if(ageWithTolerance <= maxAge) {
    return {
      ok: true,
    }
  }else {
    return {
      ok: false,
      message: `Ihr Kind überschreitet das Höchstalter von ${maxAge} Jahren${tolerance > 0 ? ` (auch mit Berücksichtigung der Alterstoleranz von ±${tolerance} Tagen)`: '' }!`
    }
  }
};

export const checkProperAge = (
  dateOfBirth: string,
  registrations: IRegistration[],
  tolerance: number
): AgeCheckResult => {
  const momDateOfBirth = moment(dateOfBirth, 'DD.MM.YYYY')

  for (const reg of registrations) {
    const res = ageInDateRange(
      [
        // if min age is not defined, assume that the participant should be born
        reg.event.min_age || 0,
        // if max age is not defined, assume no upper limit
        reg.event.max_age || Number.POSITIVE_INFINITY,
      ],
      asDateRange(
        reg.event.start ? moment(reg.event.start) : moment(),
        reg.event.end ? moment(reg.event.end) : moment().add(1, 'y')
      ),
      momDateOfBirth,
      tolerance,
      !reg.event.start && !reg.event.end
    )

    if (res !== AgeInDateRangeResults.OK) {
      return {
        ok: false,
        message: `Das Alter stimmt zu ${res} der Veranstaltung “${reg.event.name
          }”${tolerance > 0
            ? `, auch mit Berücksichtigung der Alterstoleranz von ±${tolerance} Tagen,`
            : ''
          } nicht mit der Altersanforderung (${reg.event.min_age || 0} - ${reg
            .event.max_age || '∞'} Jahren) überein.`,
      }
    }
  }
  return {
    ok: true,
  }
}
